import React, { useEffect, useState } from "react";
import Select from "react-select";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const ProjectRequirementReport = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState({
  value: "ALL",
  label: "All"
});
const typeOptions = [
  { value: "ALL", label: "All" },
  { value: "CONSUMABLES", label: "Consumables" },
  { value: "NON_CONSUMABLES", label: "Non-Consumables" }
];

  const navigate = useNavigate();
  useEffect(() => {
    apiClient.get(`${SERVER_BASE}/area-projects`).then(res => {
      setProjects(
        res.data.map(p => ({
          value: p.id,
          label: p.projectName
        }))
      );
    });
  }, []);

  const handleGetData = () => {
    if (!selectedProjects.length) {
      alert("Select project");
      return;
    }

    setLoading(true);
    apiClient
      .get(`${SERVER_BASE}/project-requirement-report`, {
        params: { projectIds: selectedProjects.map(p => p.value).join(",") }
      })
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
      
  };
  const filteredData = data.filter(item => {
  if (typeFilter.value === "ALL") return true;
  if (typeFilter.value === "CONSUMABLES")
    return item.type === "Consumables";
  if (typeFilter.value === "NON_CONSUMABLES")
    return item.type !== "Consumables";
  return true;
});


  return (
    <div className="formcontainer">
      {/* FILTER */}
      <div className="d-flex align-items-center mb-3">

        <button
          className="btn btn-secondary btn-sm me-3"
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
        </button>

        <h5 className="mb-0">Project Item Report</h5>
      </div>
<div className="row mb-3 align-items-end">
  {/* PROJECT SELECT */}
  <div className="col-md-6">
    <label className="form-label fw-bold">Select Projects</label>
    <Select
      isMulti
      options={projects}
      value={selectedProjects}
      onChange={setSelectedProjects}
    />
  </div>

  {/* ITEM TYPE FILTER (SHOW ONLY AFTER DATA LOADS) */}
  {data.length > 0 && (
    <div className="col-md-3">
      <label className="form-label fw-bold">Item Type</label>
      <Select
        options={typeOptions}
        value={typeFilter}
        onChange={setTypeFilter}
      />
    </div>
  )}

  {/* GET DATA BUTTON */}
  <div className="col-md-2">
    <button
      className="btn btn-primary w-100"
      onClick={handleGetData}
      disabled={loading}
    >
      {loading ? "Loading..." : "Get Data"}
    </button>
  </div>
</div>


      {/* MAIN TABLE */}
      {data.length > 0 && (
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Item</th>
              <th className="text-end">Required Qty</th>
              <th className="text-end">Received Qty</th>
              <th className="text-end">Balance to Receive</th>
              <th className="text-end">Returned Qty</th>

              {/* NEW */}
              <th className="text-end">Balance to Return</th>

              <th>UOM</th>
            </tr>
          </thead>


          <tbody>
            {filteredData.map(item => (
              <React.Fragment key={item.itemId}>
                {/* SUMMARY ROW */}
                <tr
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setExpandedRows(p => ({
                      ...p,
                      [item.itemId]: !p[item.itemId]
                    }))
                  }
                >
                  <td>
                    <strong>{item.itemName}</strong>
                  </td>

                  <td className="text-end">{item.totalQty}</td>
                  <td className="text-end">{item.receivedQty}</td>
                  <td className="text-end fw-bold text-danger">
                    {(Number(item.totalQty || 0) - Number(item.receivedQty || 0)).toFixed(2)}
                  </td>
                  {/* PENDING TO RECEIVE */}
                  <td className="text-end">{item.returnedQty}</td>


                  {/* PENDING TO RETURN */}
                  <td className="text-end fw-bold text-warning">
                    {(Number(item.receivedQty || 0) - Number(item.returnedQty || 0)).toFixed(2)}
                  </td>

                  <td>{item.uom}</td>
                </tr>


                {/* EXPANDED ROW */}
                {expandedRows[item.itemId] && (
                  <tr>
                    <td colSpan="7" className="bg-light">
                      <div className="row g-3">

                        {/* ================= REQUIREMENT ================= */}
                        <div className="col-md-4">
                          <div className="card h-100">
                            <div className="card-header fw-bold">
                              Requirement
                            </div>
                            <div className="card-body p-2">
                              <table className="table table-sm table-bordered mb-0">
                                <thead>
                                  <tr>
                                    {/* <th>Source</th> */}
                                    <th>Reference</th>
                                    <th>Remarks</th>
                                    <th className="text-end">Qty</th>
                                    <th>UOM</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.requirementDetails?.length > 0 ? (
                                    item.requirementDetails.map((r, i) => (
                                      <tr key={i}>
                                        {/* <td>{r.source}</td> */}
                                        <td>
                                          {r.source === "PROJECT_REQUIREMENT" && (
                                            <>
                                              {r.department}
                                              <br />
                                              <small>{r.requirementCode}</small>
                                            </>
                                          )}
                                          {r.source === "MR" && (
                                            <>
                                              {r.mrNo}
                                              <br />
                                              <small>{r.mrDate}</small>
                                            </>
                                          )}
                                        </td>
                                        <td>
                                          {r.source === "MR"
                                            ? r.remarks || "-"
                                            : "-"}
                                        </td>
                                        <td className="text-end">{r.qty}</td>
                                        <td>{item.uom}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="7" className="text-muted text-center">
                                        No requirement data
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* ================= RECEIVED ================= */}
                        <div className="col-md-4">
                          <div className="card h-100">
                            <div className="card-header fw-bold">
                              Received
                            </div>
                            <div className="card-body p-2">
                              <table className="table table-sm table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th>RV No</th>
                                    <th>Ledger</th>
                                    <th className="text-end">Qty</th>
                                    <th>UOM</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.receiptDetails?.length > 0 ? (
                                    item.receiptDetails.map((r, i) => (
                                      <tr key={i}>
                                        <td>{r.rvNo}</td>
                                        <td>{r.ledgerName}</td>
                                        <td className="text-end">
                                          {r.receivedQty}
                                        </td>
                                        <td>{r.uom || item.uom}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4" className="text-muted text-center">
                                        No received data
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* ================= RETURNED ================= */}
                        <div className="col-md-4">
                          <div className="card h-100">
                            <div className="card-header fw-bold">
                              Returned
                            </div>
                            <div className="card-body p-2">
                              <table className="table table-sm table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th>Ref No</th>
                                    <th>Ledger</th>
                                    <th className="text-end">Qty</th>
                                    <th>UOM</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.returnDetails?.length > 0 ? (
                                    item.returnDetails.map((r, i) => (
                                      <tr key={i}>
                                        <td>{r.refNo}</td>
                                        <td>{r.ledger}</td>
                                        <td className="text-end">
                                          {r.returnedQty}
                                        </td>
                                        <td>{r.uom || item.uom}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4" className="text-muted text-center">
                                        No return data
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ProjectRequirementReport;
